module.exports = __webpack_public_path__ + "static/media/Single Matting with Multiple Opening.fea232c1.png";